import comp from "./LoadingComponent";
export default comp;
